
// TODO: Fix for dropdown closing for q-select after receiving options.
import { useQuasar, QSelect, QSelectProps } from 'quasar';
import { defineComponent, ref } from 'vue';
import API from 'boot/api';
import { matClear } from '@quasar/extras/material-icons';

export default defineComponent({
  name: 'ChannelSelector',
  props: {
    modelValue: {
      type: String,
      default: '',
    },
  },
  emits: [
    'selected-value',
  ],
  setup() {
    const $q = useQuasar();
    let abortRequest: AbortController | undefined;

    const selectRef = ref<QSelect>();
    const loading = ref(false);
    const channels = ref<readonly string[]>(Object.freeze([]));

    const onRequest = async (name: string) => {
      try {
        loading.value = true;
        if (abortRequest) {
          // Cancel ongoing request.
          abortRequest.abort();
        }

        const { request, controller } = API.getChannelsAutoComplete(name);

        abortRequest = controller;
        const result = await request;
        channels.value = Object.freeze(result);

        // Reset component, because the popup is hidden in some cases.
        selectRef.value?.refresh(0);
      } catch (err) {
        if (err instanceof DOMException && err.name === 'AbortError') {
          // Ignore abort errors.
          return;
        }

        $q.notify({
          type: 'negative',
          message: String(err),
        });
      } finally {
        loading.value = false;
      }
    };

    const onFilter: QSelectProps['onFilter'] = (value, update) => {
      // Clear channels, because the filter changed.
      channels.value = Object.freeze([]);

      const onUpdate = () => onRequest(value);
      update(onUpdate as () => void);
    };

    return {
      loading,
      channels,
      onFilter,
      matClear,
      selectRef,
    };
  },
});
